import { GetStaticPaths, GetStaticPathsContext, GetStaticProps, GetStaticPropsContext } from 'next';

import VideoPage, {
  getStaticPaths as getCourseStaticPaths,
  getStaticProps as getCourseStaticProps,
} from '@edx/pages/courses/[courseSlug]/[video]';

export const getStaticPaths: GetStaticPaths = (context: GetStaticPathsContext) =>
  getCourseStaticPaths(context, 'ejercicios');

export const getStaticProps: GetStaticProps = (context: GetStaticPropsContext) =>
  getCourseStaticProps(context, 'ejercicios');

export default VideoPage;
